var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('CoolLightBox',{attrs:{"items":_vm.images,"index":_vm.index,"useZoomBar":true},on:{"close":function($event){_vm.index = null}}}),_c('div',{staticClass:"images-wrapper"},_vm._l((_vm.images),function(image,imageIndex){return _c('div',{key:imageIndex,staticClass:"image",style:({
        backgroundImage: ("url('" + (image.src) + "')"),
        backgroundSize: 'cover'
      }),on:{"click":function($event){_vm.index = imageIndex}}})}),0)],1)}
var staticRenderFns = []

export { render, staticRenderFns }